import React from 'react';

export default function GameTileGrid({ items, className = '' }) {
	if(!items || items.length === 0) {
		return null;
	}
	return (
		<div className={`game-tile-grid ${className}`.trim()}>
			{items.map((item) => {
				const { key, label, image, href, onClick, style } = item;
				const onClickHandler = onClick
					? (event) => onClick(event, item)
					: undefined;
				return (
					<a
						key={key}
						href={href || '#'}
						onClick={onClickHandler}
						title={label}
						style={style}
						className={style ? 'game-tile game-tile--colored' : 'game-tile'}
					>
						<div className='game-tile__image-frame'>
							{image
								? <img src={image} alt={label} className='game-tile__image' />
								: <span className='game-tile__image-fallback'>{label?.[0] ?? '?'}</span>
							}
						</div>
						<div className='game-tile__label'>{label}</div>
					</a>
				);
			})}
		</div>
	);
}
